import common from './common.json';
import nav from './nav.json';
import api from './api.json';
import models from './models.json';
import auth from './auth';
import pages from './pages';
import modals from './modals';
import components from './components';

export default {
  common,
  nav,
  api,
  models,
  ...auth,
  ...pages,
  ...modals,
  ...components,
};
